import AMApp from './global/app.js';
import { HeaderSearch } from './modules/header/HeaderSearch';
import AvailableFonds from './modules/availablefonds/AvailableFonds';
import BrochureCenter from './modules/brochurecenter/BrochureCenter';
import Dividend from './modules/brochurecenter/Dividend';
import FondsPrices from './modules/brochurecenter/FondsPrices';
import RuecknahmeAussetzungen from './modules/brochurecenter/RuecknahmeAussetzungen';
import { CustomChart } from './modules/customchart/CustomChart';
import { Dropdown } from './modules/dropdown/Dropdown';
import Preisabo from './modules/forms/Preisabo';
import { getActual, Actual } from './modules/header/Actual';
import NavigationManager from './modules/header/NavigationManager';
import HistoricalFondsPrices from './modules/historicalfondsprices/HistoricalFondsPrices';
import { HistoryClass } from './modules/history/HistoryClass';
import { initTooltips } from './modules/tooltip/ToolTipp';
import TopFonds from './modules/topfonds/TopFonds';
import initTopLink from './modules/toplink/toplink';
import FondsFinder from './modules/fondsfinder/FondsFinder';
import SiteSearch from './modules/sitesearch/SiteSearch,js';
import { initSmoothScroll } from './global/SmoothScroll';
import TogglePane from './global/TogglePane';
import Gallery from './modules/gallery/Gallery';
import FondsRecommendation from './modules/fondsrecommendation/FondsRecommendation';
import PrintHelper from './global/PrintHelper';

document.addEventListener('DOMContentLoaded', () => {
    console.log('DOMContentLoaded');

    // Tablesaw initialisieren
    //autoInitTablesaw();

    // Gallery initialization
    const galleries = document.querySelectorAll('.js_gallery');
    galleries.forEach(gallery => {
      gallery._galleryInstance = new Gallery(gallery);
    });

    /**
     * Print area
     */
    document.addEventListener('click', function (e) {
      // Print area button
      if (e.target.closest('.js_print_area-btn')) {
        const printArea = e.target.closest('.js_print_area');
        if (printArea) {
          // Simple print implementation - you might want to use a proper print library
          PrintHelper.printElement(printArea);
        }
      }

      // Print content button
      if (e.target.closest('.js_print_content-btn')) {
        // Toggle all elements with data-toggle-target to active
        const toggleElements = document.querySelectorAll('[data-toggle-target]');
        toggleElements.forEach(element => {
          element.classList.add('toggle__active');
        });

        // Print the whole body
        window.print();
      }
    });

    const newsarticles = document.getElementById('newsarticles');
    if (newsarticles) {
      const newsElements = newsarticles.querySelectorAll('.news');
      newsElements.forEach(element => {
        element.classList.add('grid', 'grid__3x2');
        element.classList.remove('news');
      });
    }

    /**
     * Init available fonds
     */
    const availableFonds = document.getElementById('availablefonds');
    if (availableFonds) {
      new AvailableFonds(availableFonds);
    }

    /**
     * Init brochure center
     */
    const brochureCenter = document.getElementById('brochurecenter');
    if (brochureCenter) {
      new BrochureCenter(brochureCenter);
    }

    /**
     * Init Ausschüttungs- und Thesaurierungsdaten
     */
    const dividend = document.getElementById('dividend');
    if (dividend) {
      console.log('dividend');
      new Dividend(dividend);
    }

    /**
     * Init Rücknahmeaussetzungen
     */
    const ruecknahmeAussetzungen = document.getElementById('ruecknahmeaussetzungen');
    if (ruecknahmeAussetzungen) {
      console.log('ruecknahmeaussetzungen');
      // Tablesaw.init();
      new RuecknahmeAussetzungen(ruecknahmeAussetzungen);
    }

    /**
     * Init Fondsprices
     */
    if (document.getElementById('fondsprices')) {
      console.log('fondsprices');
      const fondsPrices = document.getElementById('fondsprices');
      new FondsPrices(fondsPrices);
    }

    /**
     * Init highcharts chart
     */
    document.querySelectorAll('[data-chart-file]')
      .forEach(element => {
        new CustomChart(element);
      });

    /**
     * Header search
     */
    const headerSearch = document.getElementById('header_search');
    if (headerSearch) {
      HeaderSearch();
    }

    /**
     * Init DropDown
     */
    document.querySelectorAll('.js_dropdown')
      .forEach(element => {
        new Dropdown(element);
      });

    /**
     * Init Preisabo
     */
    const preisaboEl = document.getElementById('preisabo');
    if (preisaboEl) {
      new Preisabo(preisaboEl);
    }

    /**
     * Init NavigationManager
     */
    const mainNav = document.getElementById('mainmenu');
    if (mainNav) {
      new NavigationManager(mainNav);
    }

    /**
     * History
     */
    const history = document.getElementById('history');
    if (history) {
      new HistoryClass();
    }

    /**
     * Historical Fonds Prices
     */
    const container = document.getElementById('historicalfondsprices');
    if (container) {
      new HistoricalFondsPrices(container);
    }

    /**
     * Init Fondsempfehlung
     */
    const elements = document.querySelectorAll('[data-fonds-recommendation]');
    if (elements.length > 0) {
      elements.forEach(el => new FondsRecommendation(el));
    }

    /**
     * Init ToolTips
     */
    initTooltips();

    /**
     * Init Fonds of the month
     */
    const topfondsElement = document.getElementById('topfonds');
    if (topfondsElement) {
      new TopFonds(topfondsElement);
    }

    /**
     * Init Toplink
     */
    initTopLink();

    /**
     * Init FondsFinder
     */
    const fondsFinderElement = document.getElementById('fondsfinder');
    if (fondsFinderElement) {
      new FondsFinder(fondsFinderElement);
    }

    /**
     * Init SiteSearch
     */
    const siteSearchElement = document.getElementById('site_search');
    if (siteSearchElement) {
      new SiteSearch(siteSearchElement);
    }

    /**
     * Smooth scroll
     */
    initSmoothScroll('.js_smooth');

    /**
     * Handle URL Hash for TogglePane (z. B. #wertentwicklung)
     */
    //TogglePane.handleHashOnLoad();

    /**
     * Event Delegation für TogglePanes (Ersatz für Klick-Handler)
     */
    document.addEventListener('click', (e) => {
      const toggleBtn = e.target.closest('[data-toggle]');
      if (toggleBtn) {
        e.preventDefault();
        const target = toggleBtn.getAttribute('data-toggle');
        const isTab = toggleBtn.classList.contains('js_tab');
        TogglePane.toggle(target, isTab);
      }
    });
  }
)
;